import React, { Component } from "react";
import { Form, Row, Col, Button, Alert, Modal, InputGroup,  Nav} from "react-bootstrap";



import { browserHistory, LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';

import DatePicker from "react-datepicker";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';





export default class LeasingAgentList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "leasingAgents",
            dataRecord: "leasingAgents",
            dataSetPrimaryKey: "leasing_agent_id",
            savingNewRecord: false,
            showAgentDialog: false,
            showAgentDropDown: false,
            agentMenuIsOpen: false,
            agentInterstateFlag: false,
            showAgentContactDropDown: false,
            selectedAgent: {value: null, label: null},
            selectedAgentContact1: null,
            selectedAgentContact2: null,
            agentOptions: [],
            agentContactOptions: [],
            agentSearchString: "",
            currentLeasingAgentIndex: null,
            showAlert: false,
            leasing_agent_telephone: "",
            leasing_agent_fax: "",
            leasing_agent_email: "",
            leasing_agent_internet: "",
            leasing_agent_contact_1_telephone: "",
            leasing_agent_contact_1_email: "",
            leasing_agent_contact_2_telephone: "",
            leasing_agent_contact_2_email: "",
            showFormAlert: false

        };

        
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);       
        this.toggleAgentModal = this.toggleAgentModal.bind(this);

    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }       

        this.setState({ isLoading: false });      
    }

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }
   

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete agent");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };



    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };


    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];

        const validation = this.props.validateRelatedRecord(data[cellInfo.index], this.state.dataSet);
        if (validation[0] === true) {
            if (data[cellInfo.index].hasOwnProperty("modified")) {
                if (data[cellInfo.index].modified === true) {
                    //Save the data
                    if (!this.state.savingNewRecord) {
                        if (data[cellInfo.index].hasOwnProperty("new_record")) {
                            if (data[cellInfo.index].new_record === true) {
                                this.setState({ savingNewRecord: true });
                            }
                        }
                        const result = await this.handleDataSave(data[cellInfo.index]);
                        if (result.result) {
                            data[cellInfo.index].modified = false;
                            if (data[cellInfo.index].hasOwnProperty("new_record")) {
                                if (data[cellInfo.index].new_record === true) {

                                    data[cellInfo.index][this.state.dataSetPrimaryKey] = result.id;
                                    this.setState({ savingNewRecord: false });
                                }
                                data[cellInfo.index].new_record = false;
                            }
                            if (data[cellInfo.index].hasOwnProperty("sort_order")) {
                                data.sort(function (a, b) { return a.sort_order - b.sort_order });
                            }
                            this.props.updateTableState(data, this.state.dataSet);
                        }
                        else {
                            this.setState({ errorMessage: result.error_message });
                            this.setState({ showAlert: true });
                        }
                    }
                }

            }
        }
        else {
            this.setState({ errorMessage: validation[1] });
            this.setState({ showAlert: true });
        }

    }


    addRecord = async event => {
        let data = [...this.props.data];

        //Minimum record to create (all not nulls populated)
        data.push({
            property_id: this.props.propertyid,
            classification_code: "",
            leasing_agent: "Click to enter",
            sort_order: 99,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (["sort_order"].indexOf(cellInfo.column.id) >= 0) {
            return (
                <input
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="number"
                    className="no-border form-control"
                    value={cellValue}
                    pattern="[0-9]*"
                />
            );
        }

        if (cellInfo.column.id.indexOf(["amble"]) >= 0) {
        return (
            <Form.Control
                onChange={this.handleInputChange.bind(null, cellInfo)}
                onBlur={this.handleSave.bind(null, cellInfo)}
                type="text"
                as="textarea"
                rows={(Math.abs((cellValue||"").length/80)+1).toString()}
                className="no-border form-control"
                value={cellValue!=null? cellValue:""}

            />
        );
        }

        


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                   
                                    
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }


    


    viewAgentModal = async (rowInfo) => {
        console.log(rowInfo);
        
            this.setState({ currentLeasingAgentIndex: rowInfo.index })
            let data = [...this.props.data];
        if (data[rowInfo.index].leasing_agent !== "Click to enter") {
            this.setState(state => ({ selectedAgent: { value: data[rowInfo.index].entity_id_leasing_agent, label: data[rowInfo.index].leasing_agent } }));
            this.setState(state => ({ leasing_agent_telephone: data[rowInfo.index].leasing_agent_telephone }));
            this.setState(state => ({ leasing_agent_fax: data[rowInfo.index].leasing_agent_fax }));
            this.setState(state => ({ leasing_agent_email: data[rowInfo.index].leasing_agent_email }));
            this.setState(state => ({ leasing_agent_internet: data[rowInfo.index].leasing_agent_internet }));

            this.setState(state => ({ selectedAgentContact1: { value: data[rowInfo.index].entity_contact_id_leasing_agent_contact_1, label: data[rowInfo.index].leasing_agent_contact_1 } }));
            this.setState(state => ({ leasing_agent_contact_1_telephone: data[rowInfo.index].leasing_agent_contact_1_telephone }));
            this.setState(state => ({ leasing_agent_contact_1_email: data[rowInfo.index].leasing_agent_contact_1_email }));

            this.setState(state => ({ selectedAgentContact2: { value: data[rowInfo.index].entity_contact_id_leasing_agent_contact_2, label: data[rowInfo.index].leasing_agent_contact_2 } }));
            this.setState(state => ({ leasing_agent_contact_2_telephone: data[rowInfo.index].leasing_agent_contact_2_telephone }));
            this.setState(state => ({ leasing_agent_contact_2_email: data[rowInfo.index].leasing_agent_contact_2_email }));


            if (data[rowInfo.index].entity_id_leasing_agent) {
                if (data[rowInfo.index].entity_id_leasing_agent) {
                    await this.props.getAgentsLeasing({ entityid: data[rowInfo.index].entity_id_leasing_agent });
                    await this.props.getLeasingAgentContacts({ entityid: data[rowInfo.index].entity_id_leasing_agent });
                }

            }
        }
        else {
            this.setState(state => ({ selectedAgent: { value: null, label: null } }));
            this.setState(state => ({ selectedAgentContact1: { value: null, label: null } }));
            this.setState(state => ({ selectedAgentContact2: { value: null, label: null } }));
            this.setState(state => ({ leasing_agent_telephone: null }));
            this.setState(state => ({ leasing_agent_fax: null }));
            this.setState(state => ({ leasing_agent_email: null}));
            this.setState(state => ({ leasing_agent_internet: null }));
            
            this.setState(state => ({ leasing_agent_contact_1_telephone: null }));
            this.setState(state => ({ leasing_agent_contact_1_email: null }));

            this.setState(state => ({ leasing_agent_contact_2_telephone: null }));
            this.setState(state => ({ leasing_agent_contact_2_email: null }));

        }

        this.setState(state => ({
            showAgentDialog: true
        }));



    }
    

    renderTable(data) {
        const columns = [

            {
                id: 'leasing_agent_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'leasing_agent_id',
                Cell: row => <Button variant="link"  size="sm" onClick={(e) =>this.viewAgentModal(row)}>{row.value}</Button>,
                maxWidth: 100

        }, {
                id: 'lease_preamble',
                Header: 'Lease Preamble',
                accessor: 'lease_preamble',
                Cell: this.renderEditable,
                maxWidth: 550,
                style: { 'white-space': 'unset' } 

            }, {
                id: 'leasing_agent',
                Header: 'Leasing Agent',
                accessor: 'leasing_agent',
                Cell: row => <div><Button variant="link" size="sm" onClick={(e) =>this.viewAgentModal(row)}>{row.value}</Button> <br/>p: {row.original.leasing_agent_telephone}<br/>e: {row.original.leasing_agent_email}<br/>i: {row.original.leasing_agent_internet}</div>,
                maxWidth: 550

            }, {
                id: 'lease_postamble',
                Header: 'Lease Postamble',
                accessor: 'lease_postamble',
                Cell: this.renderEditable,
                maxWidth: 550,
                style: { 'white-space': 'unset' } 

            },
            {
                id: 'sort_order',
                Header: 'Sort Order',
                accessor: 'sort_order',
                maxWidth: 85,
                Cell: this.renderEditable

            },
            {
                id: 'agent_details',
                Header: 'Contacts',                                
                Cell: row=><div><b>Contact 1: </b>{row.original.leasing_agent_contact_1} t: {row.original.leasing_agent_contact_1_telephone} e: {row.original.leasing_agent_contact_1_email}  <br/><b>Contact 2: </b>{row.original.leasing_agent_contact_2} t: {row.original.leasing_agent_contact_2_telephone} e: {row.original.leasing_agent_contact_2_email} </div>
            },
            {
                Header: '',
                accessor: 'leasing_agent_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Delete</Button>,
                maxWidth: 150
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                    //getTrProps={(state, rowInfo, column, instance) => ({
                    //    onClick: e => this.viewAgentModal(rowInfo)
                    //})}
                />
            )
        }



    }

    



    renderTable2(data) {
        const columns = [

            {
                id: 'property_key',
                Header: 'Cityscope Reference',
                maxWidth: 120,
                accessor: 'property_key',
                Cell: e=> <LinkContainer to={`/properties/${e.original.property_key}`} ><a>{e.original.property_key}</a></LinkContainer>
            }, {
                id: 'lease_preamble',
                Header: 'Lease Preamble',
                accessor: 'lease_preamble',
                maxWidth: 550

            }, {
                id: 'leasing_agent',
                Header: 'Leasing Agent',
                accessor: 'leasing_agent',                
                maxWidth: 550

            }, {
                id: 'lease_postamble',
                Header: 'Lease Postamble',
                accessor: 'lease_postamble',
                maxWidth: 550

            },
            {
                id: 'sort_order',
                Header: 'Sort Order',
                accessor: 'sort_order',
                maxWidth: 85

            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                    getTrProps={this.getTrProps}
                    //getTrProps={(state, rowInfo, column, instance) => ({
                    //    onClick: e => this.viewAgentModal(rowInfo)
                    //})}
                />
            )
        }



    }

    
    toggleAgentModal = async () => {
        this.setState(state => ({
            showAgentDialog: !this.state.showAgentDialog
        }));

    }


    handleFormInputChange = event => {
        this.setState({ [event.target.id]: event.target.value });
        let data = [...this.props.data];
        data[this.state.currentLeasingAgentIndex][event.target.id] = event.target.value;
        data[this.state.currentLeasingAgentIndex].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleFormBlur = async event => {
        this.setState({ showFormAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                console.log();
                                if( result.entity_contact_id_leasing_agent_contact_1 !== null)
                                {
                                    console.log("Setting entity contact 1");
                                    data[i].entity_contact_id_leasing_agent_contact_1 = result.entity_contact_id_leasing_agent_contact_1;
                                    this.setState({ selectedAgentContact1: {value: result.entity_contact_id_leasing_agent_contact_1, label: this.state.leasing_agent_contact_1} });
                                    await this.props.getLeasingAgentContacts({ entityid: data[i].entity_id_leasing_agent });
                                }

                                if(result.entity_contact_id_leasing_agent_contact_2 !== null)
                                {
                                    console.log("Setting entity contact 2");
                                    data[i].entity_contact_id_leasing_agent_contact_2 = result.entity_contact_id_leasing_agent_contact_2;
                                    this.setState({ selectedAgentContact2: {value: result.entity_contact_id_leasing_agent_contact_2, label: this.state.leasing_agent_contact_2} });
                                    await this.props.getLeasingAgentContacts({ entityid: data[i].entity_id_leasing_agent });
                                }
            
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                return;
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);


    }

    handleCheckBoxChange = event => {
        
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
             })
        

     

    }


    handleAgentSearch = async () => {
        try {
            if (this.state.showAgentDropDown) {
                this.setState(state => ({
                    showAgentDropDown: false
                }));
            }
            let state = null;
            if (!this.state.agentInterstateFlag) {
                    state = this.props.state;
            }

            await this.props.getAgentsLeasing({ name: this.state.agentSearchString,state: state });
            this.setState(state => ({
                showAgentDropDown: true
            }));
            this.setState({ agentMenuIsOpen: true});
        }
        catch{
            alert("Error loading proposals");
        }
    }

    handleEnterOnAgentSearch = (e) => {
        if (e.keyCode === 13) {
            this.handleAgentSearch();

        }
    }

    handleAgentChange = async (selectedAgent) => {
        console.log(selectedAgent);
        this.setState({ modified: true });
        this.setState(state => ({ selectedAgent }));
        this.setState({ agentMenuIsOpen: false
                        ,selectedAgentContact1: { value: null, label: null }
                        ,selectedAgentContact2: { value: null, label: null }
                        ,leasing_agent_contact_1_telephone: "" 
                        ,leasing_agent_contact_1_email: "" 
                        ,leasing_agent_contact_2_telephone: "" 
                        ,leasing_agent_contact_2_email: ""
                        ,leasing_agent_telephone: ""
                        ,leasing_agent_fax: ""
                        ,leasing_agent_email: ""
                        ,leasing_agent_internet: ""
                    });


        let data = [...this.props.data];
        data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_1 = null;
        data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1 = null;
        data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_telephone = null;
        data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_email = null;

        data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_2 = null;
        data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2 = null;
        data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_telephone = null;
        data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_email = null;

        data[this.state.currentLeasingAgentIndex].modified = true;

        

        if (selectedAgent) {
            this.setState({ leasing_agent_telephone: selectedAgent.telephone
                            ,leasing_agent_fax: selectedAgent.fax 
                            ,leasing_agent_email: selectedAgent.email 
                            ,leasing_agent_internet: selectedAgent.internet });

            //Reset state based on selection
            
            data[this.state.currentLeasingAgentIndex].entity_id_leasing_agent = selectedAgent.value;
            data[this.state.currentLeasingAgentIndex].leasing_agent = selectedAgent.label;
            data[this.state.currentLeasingAgentIndex].leasing_agent_telephone = selectedAgent.telephone;
            data[this.state.currentLeasingAgentIndex].leasing_agent_fax = selectedAgent.fax;
            data[this.state.currentLeasingAgentIndex].leasing_agent_email = selectedAgent.email;
            data[this.state.currentLeasingAgentIndex].leasing_agent_internet = selectedAgent.internet;

            //Get contacts
            await this.props.getLeasingAgentContacts({ entityid: selectedAgent.value });

            

        } else {
            this.setState({ leasing_agent_telephone: null });
            this.setState({ leasing_agent_fax: null });
            this.setState({ leasing_agent_email: null });
            this.setState({ leasing_agent_internet: null });

            this.setState(state => ({ selectedAgent: { value: null, label: null } }));

            data[this.state.currentLeasingAgentIndex].entity_id_leasing_agent = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_telephone = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_fax = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_email = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_internet = null;
          
        }
        this.props.updateTableState(data, this.state.dataSet);


    }

    handleCreateContact1InputChange = (selectedAgentContact1) => {
        console.log("In handleCreateContact1InputChange");
        let confirmed = window.confirm("Are you sure you want to create a contact for this agent?");
        if (!confirmed) {
            return
        }
        console.log(selectedAgentContact1);
        let data = [...this.props.data];
        data[this.state.currentLeasingAgentIndex].modified = true;
        
        if (selectedAgentContact1) {
            
            this.setState({ entity_contact_id_leasing_agent_contact_1: null 
                            ,leasing_agent_contact_1: selectedAgentContact1 
                            ,leasing_agent_contact_1_telephone: ""
                            ,leasing_agent_contact_1_email: "" 
                            , selectedAgentContact1: {value: selectedAgentContact1, label: selectedAgentContact1}});            

            
            data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_1 = "";
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1 = selectedAgentContact1;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_telephone = "";
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_email = "";
        }
        else{
            this.setState({ entity_contact_id_leasing_agent_contact_1: null 
                ,leasing_agent_contact_1: "" 
                ,leasing_agent_contact_1_telephone: ""
                ,leasing_agent_contact_1_email: "" 
                , selectedAgentContact1: {value: "", label: ""}});  
        }
    }

    handleCreateContact2InputChange = (selectedAgentContact2) => {
        console.log("In handleCreateContact2InputChange");
        let confirmed = window.confirm("Are you sure you want to create a contact for this agent?");
        if (!confirmed) {
            return
        }
        console.log(selectedAgentContact2);
        let data = [...this.props.data];
        data[this.state.currentLeasingAgentIndex].modified = true;
        if (selectedAgentContact2) {
            this.setState({ selectedAgentContact2 });
            this.setState({ entity_contact_id_leasing_agent_contact_2: null 
                            ,leasing_agent_contact_2: selectedAgentContact2 
                            ,leasing_agent_contact_2_telephone: ""
                            ,leasing_agent_contact_2_email: ""
                            , selectedAgentContact2: {value: selectedAgentContact2, label: selectedAgentContact2} });            

            
            data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_2 = "";
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2 = selectedAgentContact2;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_telephone = "";
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_email = "";
        }
        else{
            this.setState({ entity_contact_id_leasing_agent_contact_2: null 
                ,leasing_agent_contact_2: "" 
                ,leasing_agent_contact_2_telephone: ""
                ,leasing_agent_contact_2_email: "" 
                , selectedAgentContact2: {value: "", label: ""}});  
        }
    }

    handleAgentContact1Change = (selectedAgentContact1) => {
        console.log("In handleAgentContact1Change");
        let data = [...this.props.data];
        data[this.state.currentLeasingAgentIndex].modified = true;
        if (selectedAgentContact1) {
            this.setState({ selectedAgentContact1 });
            this.setState({ entity_contact_id_leasing_agent_contact_1: selectedAgentContact1.value 
                        ,leasing_agent_contact_1: selectedAgentContact1.label 
                        , leasing_agent_contact_1_telephone: selectedAgentContact1.telephone 
                        , leasing_agent_contact_1_email: selectedAgentContact1.email });            

            
            data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_1 = selectedAgentContact1.value;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1 = selectedAgentContact1.label;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_telephone = selectedAgentContact1.telephone;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_email = selectedAgentContact1.email;
        }
        else {

            this.setState({ selectedAgentContact1: { value: null, label: null }
                            ,entity_contact_id_lease_agent_contact_1: null 
                            ,leasing_agent_contact_1: "" 
                            ,leasing_agent_contact_1_telephone: "" 
                            ,leasing_agent_contact_1_email: "" });     
            
            data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_1 = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1 = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_telephone = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_1_email = null;
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    handleAgentContact2Change = (selectedAgentContact2) => {
        console.log("In handleAgentContact2Change");
        let data = [...this.props.data];
        data[this.state.currentLeasingAgentIndex].modified = true;
        if (selectedAgentContact2) {
            this.setState({ selectedAgentContact2 });
            this.setState({ entity_contact_id_leasing_agent_contact_2: selectedAgentContact2.value 
                        ,leasing_agent_contact_2: selectedAgentContact2.label 
                        , leasing_agent_contact_2_telephone: selectedAgentContact2.telephone 
                        , leasing_agent_contact_2_email: selectedAgentContact2.email });  

            data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_2 = selectedAgentContact2.value;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2 = selectedAgentContact2.label;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_telephone = selectedAgentContact2.telephone;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_email = selectedAgentContact2.email;
        }
        else {

            this.setState({ selectedAgentContact2: { value: null, label: null }
                        ,entity_contact_id_lease_agent_contact_2: null 
                        ,leasing_agent_contact_2: "" 
                        ,leasing_agent_contact_2_telephone: "" 
                        ,leasing_agent_contact_2_email: "" });  
            
            data[this.state.currentLeasingAgentIndex].entity_contact_id_leasing_agent_contact_2 = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2 = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_telephone = null;
            data[this.state.currentLeasingAgentIndex].leasing_agent_contact_2_email = null;
        }
        this.props.updateTableState(data, this.state.dataSet);
    }


    renderComponent() {
        return (
            <div className="leasingAgents">

                
                    <Modal
                    show={this.state.showAgentDialog}
                    onHide={this.toggleAgentModal}
                    dialogClassName="modal-90h"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Agent</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ 'overflowX': 'scroll' }}>

                        <Form>
                            
                            <Row>
                                <Form.Group as={Col} controlId="agentSearchString" >
                                    <Form.Label className="text-right"  sm={6} md={6} lg={1}>Leasing Agent</Form.Label>
                               
                                        <InputGroup size="sm" >
                                            <Form.Control
                                                onChange={this.handleFormInputChange}
                                                value={this.state.agentSearchString}
                                                onKeyDown={this.handleEnterOnAgentSearch}
                                                as="input"
                                                type="text"
                                                placeholder="Search entities"
                                            />
                                            <InputGroup.Append><Button onClick={this.handleAgentSearch} variant="outline-secondary" size="sm">Search</Button></InputGroup.Append>
                                        </InputGroup>
                                       
                                                <Form.Check
                                                    checked={this.state.agentInterstateFlag}
                                                    onChange={this.handleCheckBoxChange}
                                                    label="Search interstate"
                                                    type="checkbox"
                                                    name="agentInterstateFlag"
                                                    onBlur={this.handleBlur}
                                                    disabled={this.state.head_record_property_id ? true : false}
                                                />

                                                                                   
                                            <Select
                                                isClearable
                                                value={this.state.selectedAgent}
                                                onChange={this.handleAgentChange}
                                            options={this.props.leasingAgentOptions}
                                        onBlur={this.handleFormBlur}
                                        menuIsOpen={this.state.agentMenuIsOpen}
                                            />
                                        


                                
                            </Form.Group>

                                <Form.Group as={Col} controlId="leasing_agent_telephone" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>Telephone</Form.Label>
                                    
                                        <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_telephone}
                                            as="input"
                                            type="text"
                                        onBlur={this.handleFormBlur}
                                        />
                                   

                                </Form.Group>
                                <Form.Group as={Col} controlId="leasing_agent_fax" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>Fax</Form.Label>
                                    
                                        <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_fax}
                                            as="input"
                                            type="text"
                                        onBlur={this.handleFormBlur}
                                        />
                                    

                                </Form.Group>
                                <Form.Group as={Col} controlId="leasing_agent_email" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>Email</Form.Label>
                                   
                                        <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_email}
                                            as="input"
                                            type="text"
                                        onBlur={this.handleFormBlur}
                                        />
                                   

                                </Form.Group>
                                <Form.Group as={Col} controlId="leasing_agent_internet" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>Website</Form.Label>
                                    
                                        <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_internet}
                                            as="input"
                                            type="text"
                                        onBlur={this.handleFormBlur}
                                        />
                                   

                                </Form.Group>


                            </Row>
                            <Row>
                                <Form.Group as={Col} controlId="entity_contact_id_lease_agent_contact_1" >
                                    <Form.Label className="text-right"  sm={6} md={6} lg={1}>Contact 1</Form.Label>
                                 
                                        
                                            <CreatableSelect
                                                isClearable
                                                value={this.state.selectedAgentContact1}
                                                onChange={this.handleAgentContact1Change}
                                                options={this.props.leasingAgentContactOptions}
                                                onCreateOption={this.handleCreateContact1InputChange}
                                                onBlur={this.handleFormBlur}
                                            />
                                        
                                   
                                </Form.Group>
                                <Form.Group as={Col} controlId="leasing_agent_contact_1_telephone" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Telephone</Form.Label>

                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_contact_1_telephone}
                                        as="input"
                                        type="text"
                                        onBlur={this.handleFormBlur}
                                    />


                                </Form.Group>
                                
                                <Form.Group as={Col} controlId="leasing_agent_contact_1_email" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Email</Form.Label>

                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_contact_1_email}
                                        as="input"
                                        type="email"
                                        onBlur={this.handleFormBlur}
                                    />


                                </Form.Group>
                            </Row>
                            <Row>
                            <Form.Group as={Col} controlId="entity_contact_id_lease_agent_contact_2" >
                                <Form.Label className="text-right"  sm={6} md={6} lg={1}>Contact 2</Form.Label>
                                

                                    <CreatableSelect
                                        isClearable
                                        value={this.state.selectedAgentContact2}
                                        onChange={this.handleAgentContact2Change}
                                        options={this.props.leasingAgentContactOptions}
                                        onCreateOption={this.handleCreateContact2InputChange}
                                        onBlur={this.handleFormBlur}
                                    />

                                
                                </Form.Group>
                                <Form.Group as={Col} controlId="leasing_agent_contact_2_telephone" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Telephone</Form.Label>

                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_contact_2_telephone}
                                        as="input"
                                        type="text"
                                        onBlur={this.handleFormBlur}
                                    />


                                </Form.Group>

                                <Form.Group as={Col} controlId="leasing_agent_contact_2_email" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Email</Form.Label>

                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.leasing_agent_contact_2_email}
                                        as="input"
                                        type="email"
                                        onBlur={this.handleFormBlur}
                                    />


                                </Form.Group>
                            </Row>
                            <Row>
                                <Col>
                                <Nav>
                                    <Nav.Item><a href={`/entities/new`} target="_blank"><Button type="button" variant="primary"  size="sm" >Create Agent</Button></a>{" "}</Nav.Item>
                                {this.state.selectedAgent.value && <Nav.Item><a href={`/entities/${this.state.selectedAgent.value}`} target="_blank"><Button type="button" variant="primary"  size="sm" >Edit Agent</Button></a></Nav.Item>}
                                </Nav>
                                </Col>
                            </Row>

                            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

                        </Form>




                        </Modal.Body>
                    </Modal>
                
                    <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                    <Col className="text-right" >
                       {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        
                        <Button variant="secondary" size="sm" onClick={this.addRecord}  >Add</Button>
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType==="table2" ?  this.renderTable2(this.props.data) : this.renderTable(this.props.data)}
                        </Col>
                    </Row>
          

            </div>
        );
    }
  render() {
    return (
        
        <div className="LeasingAgentList">           
            {this.props.isAuthenticated && this.props.data ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
